var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "content" } },
    [
      _c("div", { staticClass: "header col-md-12" }, [
        _c("div", { staticClass: "header-inner row align-items-center" }, [
          _c("div", { staticClass: "col left" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sidebar.categories")) +
                  " > " +
                  _vm._s(_vm.$t("sidebar.create")) +
                  "\n        "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content col-md-12" },
        [
          !_vm.ready
            ? _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))])
            : _vm._e(),
          _vm._v(" "),
          _vm.ready
            ? [
                _c("section", [
                  _c(
                    "div",
                    { staticClass: "col-md-12 no-padding" },
                    [
                      _c("section-header", {
                        attrs: { title: _vm.$t("message.category") }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "form-group row mb-0" }, [
                            _c("div", { staticClass: "col-md-12" }, [
                              _c("label", [
                                _vm._v(
                                  _vm._s(_vm.$t("message.category_name")) + " *"
                                )
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.textfield.category_name,
                                    expression: "textfield.category_name"
                                  }
                                ],
                                ref: "category_name",
                                staticClass: "form-control category-name",
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.textfield.category_name
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.textfield,
                                      "category_name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.items.length > 0 &&
                _vm.textfield.category_name.trim().length > 0
                  ? _c(
                      "section",
                      {
                        staticClass: "assign-items mt-3",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "col-md-12 no-padding" },
                          [
                            _c("section-header", {
                              attrs: {
                                title:
                                  _vm.$t("message.assignitems") +
                                  " (" +
                                  _vm.assignitems.length +
                                  ")"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-md-12 row align-items-center no-padding no-margin subheader-assign"
                              },
                              [
                                _c("div", { staticClass: "col no-padding" }, [
                                  _vm._v(_vm._s(_vm.$t("message.productlist")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.items, function(item, index) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-12 row align-items-center no-padding no-margin item",
                                  class: { active: item.active },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleAssign(item)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "col" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.product_name) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col text-right" }, [
                                    !item.active
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(item.category_name) +
                                              "\n              "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.active
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.textfield.category_name
                                              ) +
                                              "\n              "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "fas fa-check-circle"
                                    }),
                                    _vm._v(" "),
                                    _c("i", { staticClass: "far fa-circle" })
                                  ])
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("section", { staticClass: "mt-4" }, [
                  _c("div", { staticClass: "col-md-12 no-padding" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("message.applyitemtopos", {
                            item: _vm.$t("sidebar.categories")
                          })
                        ) +
                        "\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://www.treesoft.io/th/manual/product#category",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.learnmore")) +
                            "\n            "
                        ),
                        _c("i", { staticClass: "fas fa-external-link-alt" })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "action-bar" }, [
                  !_vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-web",
                            on: {
                              click: function($event) {
                                return _vm.save()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.save")))]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.app.loading
                    ? _c("div", { staticClass: "col-md-12 text-right" }, [
                        _vm._m(0)
                      ])
                    : _vm._e()
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("BaseConfirmDiscardModal", {
        attrs: { show: _vm.confirmDiscardModal.show },
        on: {
          onCancel: _vm.handleDiscardCancleModal,
          onConfirm: _vm.handleDiscardConfirmModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "btn btn-web", attrs: { disabled: "" } },
      [_c("i", { staticClass: "fas fa-spinner spin" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-731e123b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731e123b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/items/category/New.vue
// module id = null
// module chunks = 